
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

function LogoutPage() {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem('admin-auth');
    navigate({ to: '/auth' });
  }, [navigate]);
  return <div className="flex items-center justify-center min-h-screen">Logging out...</div>;
}

export const Route = createFileRoute('/(authentication)/auth/logout')({
  component: LogoutPage,
});
